import { environment } from '../environment';
import axios from 'axios'
import dayjs from 'dayjs';
import { auth, grantTypeEnum } from './token-Service';
import { AlertService } from './alert-service';
import t from 'i18next';
import { Base64Encoder, checkDpSuccess, decodeJWT, handleSessionClear, loginClientId, setTokenInfo, writeToken } from './tool-service';
import { getRefreshToken, revocationToken } from './dgr-service';
import { deleteMultipartFile } from './api-file';
// import history from '../history.js';



let signCode;

let redo = false;

const service = axios.create({
    baseURL: environment.apiUrl,
})

service.interceptors.request.use(function (config) {
    // console.log('request interceptor:', config)
    // if (sessionStorage.getItem('access_token')) {
    //     config.headers = {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
    //     };
    // }
    // Do something before request is sent
    return config;
}, function (error) {
    // Do something with request error
    console.log("Promise token reject ",error);
    return Promise.reject(error);
});

// service.interceptors.response.use(function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response;
// }, function (error) {
//     console.log('first')
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     return Promise.reject(error);
// });







// 把服務封裝起來，呼叫時比較簡單
export const api = async option => {
    return await service({
        url: option.url,
        method: option.method || 'GET',
        data: option.data || {},
        params: option.params || {},
        headers: option.headers || {}
    })
        .then(res => res) //成功
        .catch(error => {
            // console.log('err', error)
            // window.location.href = `/${environment.contextPath}/${environment.contextVersion}/login`;
            // console.log(error?.response?.status);

            // if(error?.response?.status===403){  //Error 2
            //     window.location.href = `/${environment.contextPath}/${environment.contextVersion}/login?re=`;
            // }else{
            //     AlertService.logout(error?.code, error?.message);
            // }

            // systemRedirect();
            // window.location.replace(`${window.location.origin}/login`)
            // return handleAuthError(err);
            // return redirect('/login');                  
            //  history.replace("/login2");

            return Promise.reject(error)
        }) //失敗
}

const serviceWithoutSignCode = axios.create({
    baseURL: environment.apiUrl
})


const serviceWithSignCode = axios.create({
    baseURL: environment.apiUrl
})

serviceWithSignCode.interceptors.request.use((config) => {
  // Do something before request is sent
  if(sessionStorage?.getItem('id_token')){
    config.headers = {
        'Authorization': `Bearer ${sessionStorage?.getItem('access_token')}`,//idToken改accessToken
        'id-token':sessionStorage?.getItem('id_token')
        // 'SignCode': signCode,
    }
 
}   

    return config;
}, function (error) {
    console.log('interceptor error:', error)
    // Do something with request error
    return Promise.reject(error);
});


/**
 * 取得 server 回應資料後的後續處理流程
 * @param {*} res server 回應資料
 * @param {function} decideForAlert 判斷是否要顯示Alert的方法；true：要顯示，false：不顯示
 * @returns 
 */
export const  subsequentProcessing = (res, decideForAlert) => {
    if (res?.data?.ResHeader?.rtnCode === "1354" || res?.data?.ResHeader?.rtnCode === "1747") {
        AlertService.logout(res.data.ResHeader.rtnCode, res.data.ResHeader.rtnMsg);
        // window.location.href = `${window.location.origin}/login`;
        // window.location.replace(`${window.location.origin}/login`)
    }
    if (res?.data?.ResHeader?.rtnCode !== "1100") {

        if (typeof decideForAlert === "function" && !decideForAlert(res)) return res

        // console.log(res);
        // 替換多國語系
        if (res?.data?.ResHeader.rtnMsg.includes('[{{') && res?.data?.ResHeader.rtnMsg.includes('}}]')) {
            let _rtnMsg = res?.data?.ResHeader.rtnMsg;
            let formControlName = _rtnMsg.substring(_rtnMsg.indexOf('{{') + 2, _rtnMsg.indexOf('}}'));
            AlertService.ok(_rtnMsg.replace(`{{${formControlName}}}`, t.t(formControlName)), '', 'warning',  res.data.ResHeader.txId);
        }
        else {
            if (res?.data?.ResHeader?.rtnCode === '0001' || res?.data?.ResHeader?.rtnCode === '0133' || res?.data?.ResHeader?.rtnCode === '0134' || res?.data?.ResHeader?.rtnCode === '0135' ||  res?.data?.ResHeader?.rtnCode === '0152' ) {
                // 登出
                AlertService.logout(res.data.ResHeader.rtnMsg, '', 'warning', res.data.ResHeader.txId);
            }else if(res?.data?.ResHeader?.rtnCode === "0141"){
                if(sessionStorage?.getItem("inviteseq")!==null){
                    window.location.replace(`/${environment.contextPath}/${environment.contextVersion}/${environment.front}/register/invite/GOOGLE`)
                }else{
                    if(sessionStorage?.getItem("loadTheme")!=='mint'){ //非管理者身分google登入驗證失敗 導入註冊頁面
                        window.location.replace(`/${environment.contextPath}/${environment.contextVersion}/${environment.front}/register/GOOGLE`)
                    }else{//管理者身分google 登入失敗導回Login
                        AlertService.ok(res.data.ResHeader.rtnMsg, '', 'warning', res.data.ResHeader.txId);
                        setTimeout(()=>{
                            window.location.replace(`/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login`)
                        },3000)
                    }
                }


            }
            else {
                AlertService.ok(res.data.ResHeader.rtnMsg, '', 'warning', res.data.ResHeader.txId);
            }
        }
    }
    return res
}



//不須打token API
export const apiS_withoutToken = async (option, redo = false, isFile = false) => {

    return await serviceWithoutSignCode({
        url: option.url,
        method: option.method || 'GET',
        data: option.data || {},
        params: option.params || {},
        responseType: option.responseType || ''
    })
        .then(res => {
            // 若為檔案ex:blob無法解析Response故直接回傳
            if (isFile) return res;
            /** 此處攔截 rtnCode */
            return subsequentProcessingWithoutToken(res);
            // return res;
        })
        .catch(async err => {
            // console.log(err);
            // console.log("ERROR.....",err?.response?.status);
            if (err.code === 'ERR_NETWORK') {
                AlertService.ok(err.name, err.code);
                // AlertService.logout(err.name, err.code); //取得版本資訊不須token 因在Login頁故不須call logout 彈出視窗
            }
            // else if (err.response && err.response.hasOwnProperty("status") && err.response.status === '401' && err.response.error.hasOwnProperty('error_description') && err.response.error.error_description.indexOf("refresh") !== -1) {
            //     AlertService.logout(t('login_timeout'));
            // }
            else if (err?.response && err?.response?.status && err?.response?.status === 401) {
                if (!redo) return await handleError_401(err, option);

            }else if(err?.response && err?.response?.data.hasOwnProperty("ResHeader")){
                AlertService.ok(err.name, err?.response?.data?.RespBody?.message);
            }else {
                // handleError_401(err, option)
                AlertService.ok(err.name, err.code);
            }
        })


}

export const subsequentProcessingWithoutToken = (res, decideForAlert) => {
    if (res?.data?.ResHeader?.rtnCode === "1354" || res?.data?.ResHeader?.rtnCode === "1747") {
        AlertService.logout(res.data.ResHeader.rtnCode, res.data.ResHeader.rtnMsg);
        // window.location.href = `${window.location.origin}/login`;
        // window.location.replace(`${window.location.origin}/login`)
    }
    if (res?.data?.ResHeader?.rtnCode !== "1100") {

        if (typeof decideForAlert === "function" && !decideForAlert(res)) return res

        // console.log(res);
        // 替換多國語系
        if (res?.data?.ResHeader.rtnMsg.includes('[{{') && res?.data?.ResHeader.rtnMsg.includes('}}]')) {
            let _rtnMsg = res?.data?.ResHeader.rtnMsg;
            let formControlName = _rtnMsg.substring(_rtnMsg.indexOf('{{') + 2, _rtnMsg.indexOf('}}'));
            AlertService.ok(_rtnMsg.replace(`{{${formControlName}}}`, t.t(formControlName)), '', 'warning', res.data.ResHeader.txId);
        }
        else {
            if (res?.data?.ResHeader?.rtnCode === '0001') {
                // 登出
                // window.location.replace(`/${environment.contextPath}/${environment.contextVersion}/login`)
                AlertService.logout(res.data.ResHeader.rtnMsg, '', 'warning', res.data.ResHeader.txId);
            }
            else {
                AlertService.ok(res?.data?.ResHeader?.rtnMsg, '', 'warning', res?.data?.ResHeader?.txId);

            }
        }
    }
    return res
}


/***
 * option API相關參數
 * redo 是否重做 預設false
 * isFile預設false 是否回傳整個res 檔案格式要整個回傳故寫true 或是 token
 * **/
export const apiS = async (option, redo = false, isFile = false) => {
    signCode = await cryptSignCode(option.data);

    return await serviceWithSignCode({
        url: option.url,
        method: option.method || 'GET',
        data: option.data || {},
        params: option.params || {},
        responseType: option.responseType || '',
        headers: option.headers || {}
    })
        .then(res => {
            // 若為檔案ex:blob無法解析Response故直接回傳
            if (isFile) return res;
            /** 此處攔截 rtnCode */
            // console.log('apis resp',res)
            return subsequentProcessing(res,option);
        })
        .catch(async err => {
            // console.log(err);
            // console.log("ERROR.....",err?.response?.status);
            if (err.code === 'ERR_NETWORK') {
                AlertService.logout(err.name, err.code);
            }
            // else if (err.response && err.response.hasOwnProperty("status") && err.response.status === '401' && err.response.error.hasOwnProperty('error_description') && err.response.error.error_description.indexOf("refresh") !== -1) {
            //     console.log("401 err",err);
            //     // AlertService.logout(t('login_timeout'));
            //     // window.location.href = `/${environment.contextPath}/${environment.contextVersion}/login`;
            // }
            else if (err?.response && err?.response?.status && (err?.response?.status === 401 || err?.response?.status === 403) ) {
                if (!redo) return await handleError_401(err, option); else return err;
            }
            else {
                // handleError_401(err, option)
                if (err?.response?.data?.ResHeader?.rtnCode === '0001' || err?.response?.data?.ResHeader?.rtnCode === '0133' || err?.response?.data?.ResHeader?.rtnCode === '0134' || err?.response?.data?.ResHeader?.rtnCode === '0135' || err?.response?.data?.ResHeader?.rtnCode === '0152' ) {
                    AlertService.logout(err?.response?.data?.ResHeader?.rtnMsg, '', 'warning', err?.response?.data?.ResHeader?.txId);
                }else{
                    AlertService.ok(err.name, err.code);
                    // AlertService.ok(`${err.request.status}\n${err.config.method}`, '','warning', `${err.request.responseURL}\n${err?.response?.data?.error}`);//以後改此方式

                }
                
            }
        })


}

/***
 * isDelFileId 下載完成後是否刪除file 
 * fileId 檔案id
 * **/
export const handleFileDownloadRes = async (res,fileName,isDelFileId=false,fileId)=>{
    if (!res?.data) {
        return;
    }
    const isJsonBlob = (data) =>  data instanceof Blob && data?.type ==="application/json"
    if(!isJsonBlob(res.data)){
        const reader = new FileReader();
        reader.onloadend = function(){
            const file = new File([res.data],fileName);
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style','display:none');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove()
        }
        reader.readAsText(res.data);

        if(isDelFileId){
            deleteMultipartFile({fileId:fileId})
                .then((res)=>{
                    if(checkDpSuccess(res)){
                       
                    }else{
                        AlertService.ok(res?.data?.ResHeader?.rtnMsg);
                    }
                })
        }
        
    }else{
        const responseData = isJsonBlob(res.data) ? (await res.data.text()) : res.data || {};
        const responseJson = (typeof responseData === "string") ? JSON.parse(responseData) : responseData;
        AlertService.ok(responseJson?.ResHeader?.rtnMsg, '', 'warning',  responseJson?.ResHeader?.txId);
    }
}

export const apiS_fileDownload = async (option, redo = false) => {

    signCode = await cryptSignCode(option.data);

    return await serviceWithSignCode({
        url: option.url,
        method: option.method || 'GET',
        data: option.data || {},
        params: option.params || {},
        responseType: option.responseType || ''
    })
        .then(res => {
            // 若為檔案ex:blob無法解析Response故直接回傳
            return (res);
          
        })
        .catch(async err => {
            if (err.code === 'ERR_NETWORK') {
                AlertService.logout(err.name, err.code);
            }
            else if (err.response && err.response.hasOwnProperty("status") && err.response.status === '401' && err.response.error.hasOwnProperty('error_description') && err.response.error.error_description.indexOf("refresh") !== -1) {
                AlertService.logout(t('login_timeout'));
            }
            else if (err?.response && err?.response?.status && (err?.response?.status === 401 || err?.response?.status === 403)) {
                 if (!redo) return await handleError_401(err, option); else return err;
            }
            else {
                AlertService.ok(err.name, err.code);
            }
        })


}

/**
 * 
 * rtnErr 是否回傳跳出錯誤訊息 預設true
 * **/
export const apiS_ignore1298 = async (option, redo = false,rtnErr=true) => {

    signCode = await cryptSignCode(option.data);

    return await serviceWithSignCode({
        url: option.url,
        method: option.method || 'GET',
        data: option.data || {},
        params: option.params || {},
        responseType: option.responseType || ''
    })
        .then(res => {
            /** 此處攔截 rtnCode */
            // console.log('apis resp',res)
            if (res?.data?.ResHeader?.rtnCode === "1354" || res?.data?.ResHeader?.rtnCode === "1747") {
                AlertService.louout(res.data.ResHeader.rtnCode, res.data.ResHeader.rtnMsg);
                // window.location.href = `${window.location.origin}/login`;
                // window.location.replace(`${window.location.origin}/login`)
            }
            // if(res?.data?.ResHeader?.rtnCode !== "1100"){

            //     // 替換多國語系
            //     if (res?.data?.ResHeader.rtnMsg.includes('[{{') && res?.data?.ResHeader.rtnMsg.includes('}}]')) {
            //         let _rtnMsg =res?.data?.ResHeader.rtnMsg;
            //         let formControlName = _rtnMsg.substring(_rtnMsg.indexOf('{{') + 2, _rtnMsg.indexOf('}}'));                
            //         AlertService.ok(_rtnMsg.replace(`{{${formControlName}}}`,t.t(formControlName)),'','warning',res.data.ResHeader.txDate + '<br/>' + res.data.ResHeader.txId);                                
            //     }
            //     else
            //     {
            //         /**
            //          * 需呼叫 eventLog 記錄錯誤訊息
            //          */
            //         // call aa0206

            //         AlertService.ok(res.data.ResHeader.rtnMsg,'','warning',res.data.ResHeader.txDate + '<br/>' + res.data.ResHeader.txId);
            //         if(res?.data?.ResHeader?.rtnCode === '0001')
            //         {
            //             // 登出
            //             window.location.href(`/${environment.contextPath}/${environment.contextVersion}/login`)
            //         }
            //     }
            // }
            return res
        })
        .catch(err => {
            // console.log(err)
            if(rtnErr){
                if (err.code === 'ERR_NETWORK') {
                    AlertService.logout(err.name, err.code);
                }
                // else if (err.response && err.response.hasOwnProperty("status") && err.response.status === '401' && err.response.error.hasOwnProperty('error_description') && err.response.error.error_description.indexOf("refresh") !== -1) {
                //     AlertService.logout(t('login_timeout'));
                // }
                else if (err?.response && err?.response?.status && (err?.response?.status === 401 || err?.response?.status === 403)) {
                    if (!redo) return  handleError_401(err, option); else return err;
                }
                else {
                    // handleError_401(err, option)
                    AlertService.ok(err.name, err.code);
                }
            }
            
        })


}


function cryptSignCode(body) {
    // console.log('generate sign code');
    const prefix = sessionStorage.getItem('signBlock');
    const bodyJosn = JSON.stringify(body);
    // console.log('cryptSignCode', prefix + bodyJosn)
    // return shajs('sha256').update(prefix + bodyJosn).digest('hex');
    return genSHA256(prefix + bodyJosn);
}

/**  SHA256 加密 */
async function genSHA256(text) {
    const textAsBuffer = new TextEncoder().encode(text);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const digest = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return digest;
}

const handleAuthError = (error, option) => {
    if (error.response) {
        if (error.response.status === '401') {
            handleError_401(error)
        }
        else if (error.response.data.hasOwnProperty('error_description') && error.response.data.error_description.indexOf("refresh") === -1) {
            // console.log('登入錯誤')
            AlertService.ok(t.t('login_fail'));
            // history.replace('/digiLogs/v3/test')
            // router.navgete('/digiLogs/v3/test');
        }
    }
    else {
        AlertService.ok(error.name, error.code);
        window.location.href = `/${environment.contextPath}/${environment.contextVersion}/login`;
    }

    throw error;
}

// export const handleError_401 = async(error, option) => {
//     return await auth('', '', grantTypeEnum.refresh_token).then(res => {
//           if (res && res?.data?.access_token) {
//               // console.log('res.access_token', res.data.access_token);
//               setTokenInfo(res.data);
//               writeToken('access_token', res.data.access_token);
//               writeToken('decode_token', JSON.stringify(decodeJWT(res.data.access_token)));
//               return apiS(option, true);
//           }
//       }).catch((err)=>{
//           // console.log("refresh token Err ",err);
//           if(err?.response?.status === 403 || err?.response?.status === 401){  //Error 3
//               window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login?re=`;
//           }
  
//       })
  
//   }

export const handleError_401 = async(error, option) => { //JWT Token過期 不合法
    const audData = JSON.parse(sessionStorage?.getItem('decode_token'))
    const params = new URLSearchParams()
    params.append('grant_type', grantTypeEnum.refresh_token)
    params.append('refresh_token', sessionStorage.getItem('refresh_token'))
    const clientId = audData?.aud!==undefined?audData?.aud:audData?.['client_id'];
    // console.log('clientId',clientId);
    return await axios.post(`${environment.apiUrl}/oauth/token`,params,{
        headers:{
            'Authorization': `Basic ${Base64Encoder(clientId+":")}`,//需要開啟PKCE
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        paramsSerializer: params => params
    })
    .then((res)=>{
        if(res && res?.data?.access_token){
            setTokenInfo(res.data);
            writeToken('access_token', res.data.access_token)
            writeToken('decode_token', JSON.stringify(decodeJWT(res.data.id_token)));
            return apiS(option, true);
        }else{
            // console.log("else",res);
            if(res?.response?.status === 401 || res?.response?.status === 403){
                window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login?re=${Base64Encoder(res?.response?.data)}`;
            }
        }
    })
    .catch((err)=>{
        // console.log('catch',err);//refreshToken過期
        if(err?.response?.status === 401 || err?.response?.status === 403){
            window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login?re=${Base64Encoder(err?.response?.data?.error)}`;
        }
    })
    
    // return await getRefreshToken(params)
    //     .then((res)=>{
    //         console.log("getRefreshToken",res);
    //         if(res && res?.data?.access_token){
    //             setTokenInfo(res.data);
    //             writeToken('access_token', res.data.access_token)
    //             writeToken('decode_token', JSON.stringify(decodeJWT(res.data.access_token)));
    //             return apiS(option, true);
    //         }else{
    //             if(res?.response?.status === 401 || res?.response?.status === 403){ //refreshToken 過期
    //                 //refreshToken 不合法
    //                 // AlertService.logout(res?.response?.data?.error, '', 'warning', res?.response?.data?.message);
    //                 handleSessionClear();//不要將loadTheme刪除 系統設定的主題色
    //                 window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login?re`;
    //             }
    //         }
    //     })
    //     .catch((err)=>{
    //         console.log("error catch 401",err);
    //         // handleSessionClear();//不要將loadTheme刪除 系統設定的主題色
    //         // AlertService.ok(res.data?.error);
    //         // window.location.href = `/${environment.contextPath}/${environment.contextVersion}/${environment.front}/login?re=`;
    //     })
}

export const systemRedirect = (tar = 'login') => {
    // console.log('system redirect..')
    // window.location.replace(`${window.location.origin}/login`)
    // window.location.href = `${environment.contextPath}/${environment.contextVersion}/${tar}`;    
    // window.location.href = `/${tar}`;    
}

export { service };
export default service;
